// TEMPORÁRIO — mock local, remover no desenvolvimento do backend.
import simulados from '@/dados-simulados/cobertura.json';

import type { CoberturaDaDre } from './contrato';

/**
 * A ÚNICA porta de entrada do dado simulado na tela Cobertura por DRE.
 *
 * Exceção do CLAUDE.md de 2026-08-22 (tela cuja API ainda não existe). Quando
 * o endpoint nascer, `carregarCoberturaPorDre` passa a consultar o servidor,
 * `dados-simulados/cobertura.json` sai do repositório na mesma PR e a tela não
 * muda.
 */

/** Sem ele o estado "carregando" nunca aparece em tela — e não se confere. */
const LATENCIA_MS = 250;

export async function carregarCoberturaPorDre(): Promise<readonly CoberturaDaDre[]> {
  await new Promise((resolve) => {
    setTimeout(resolve, LATENCIA_MS);
  });
  return simulados.porDre as readonly CoberturaDaDre[];
}
